import { render } from "./Register.vue?vue&type=template&id=0463bade"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=0463bade&lang=scss"
script.render = render

export default script